export type BillingCustomerType = 'user' | 'team';
export type PlanPriceUnit = 'account' | 'seat';

export interface PlanCustomerPolicy {
  eligibleCustomerTypes: readonly BillingCustomerType[];
  priceUnit: PlanPriceUnit;
}

/** Explicit policies for the shipped catalog. New/custom plans require a policy
 * before customer-facing requests or checkout can select them. */
const CATALOG: Readonly<Record<string, PlanCustomerPolicy>> = {
  free: { eligibleCustomerTypes: ['user', 'team'], priceUnit: 'account' },
  personal_pro: { eligibleCustomerTypes: ['user'], priceUnit: 'account' },
  team: { eligibleCustomerTypes: ['team'], priceUnit: 'seat' },
  enterprise: { eligibleCustomerTypes: ['team'], priceUnit: 'seat' },
};

const UNKNOWN: PlanCustomerPolicy = { eligibleCustomerTypes: [], priceUnit: 'account' };

export function planCustomerPolicy(code: string): PlanCustomerPolicy {
  return Object.prototype.hasOwnProperty.call(CATALOG, code) ? CATALOG[code]! : UNKNOWN;
}
